<template>
  <section class="personal-center-panel">
    <h2>参会资料</h2>
    <p v-if="front.participantLockMessage" class="status-hint warning">{{ front.participantLockMessage }}</p>
    <p v-for="item in front.participantInfoItems" :key="item">{{ item }}</p>
    <button type="button" class="primary-action compact" @click="front.goServicesTab('conference')">前往会议服务</button>
  </section>
</template>

<script>
export default {
  name: 'PersonalParticipantPanel',
  inject: ['front']
}
</script>
